var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListOutdoorWifiAp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.56 7.537c-6.119-6.111-15.001-6.111-21.12 0-.586.585-.587 1.535-.001 2.122s1.535.587 2.122.001c4.891-4.885 11.989-4.885 16.88 0 .293.292 1.188.819 2.122-.001.623-.547.584-1.536-.001-2.122z",
    fill: "#246abf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.24 12.381c-.586.585-.587 1.535-.001 2.122s1.535.587 2.122.001c2.818-2.815 6.462-2.815 9.28 0 .293.292 1.243.818 2.122-.001.606-.565.584-1.536-.001-2.122-3.98-3.975-9.54-3.975-13.521 0z",
    fill: "#246abf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 15.196c-1.832 0-2.925 1.089-2.925 2.915s1.093 2.914 2.925 2.914 2.925-1.089 2.925-2.914-1.093-2.915-2.925-2.915z",
    fill: "#246abf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListOutdoorWifiAp);
export default __webpack_public_path__ + "static/media/menu_list-outdoor_wifi_ap.39546031a854e68c87bf9106aeeaa8b8.svg";
export { ForwardRef as ReactComponent };